export const SET_SAFETY_PROJECTS = 'SET_SAFETY_PROJECTS';
export const CREATE_SAFETY_PROJECT = 'CREATE_SAFETY_PROJECT';
export const UPDATE_SAFETY_PROJECT = 'UPDATE_SAFETY_PROJECT';
export const DELETE_SAFETY_PROJECT = 'DELETE_SAFETY_PROJECT';

export const SET_DAILY_FORMS = 'SET_DAILY_FORMS';
export const SET_DAILY_FORM_DETAIL = 'SET_DAILY_FORM_DETAIL';

export const SET_SKYCLIMBER_FORMS = 'SET_SKYCLIMBER_FORMS';
export const SET_SKYCLIMBER_FORM_DETAIL = 'SET_SKYCLIMBER_FORM_DETAIL';

export const SET_TOOLBOX_TALKS = 'SET_TOOLBOX_TALKS';
export const UPDATE_TOOLBOX_TALK = 'UPDATE_TOOLBOX_TALK';
export const CREATE_TOOLBOX_TALK = 'CREATE_TOOLBOX_TALK';

export const SET_SAFETY_DOCUMENTS = 'SET_SAFETY_DOCUMENTS';
export const UPDATE_SAFETY_DOCUMENT = 'UPDATE_SAFETY_DOCUMENT';
export const CREATE_SAFETY_DOCUMENT = 'CREATE_SAFETY_DOCUMENT';

export const SET_SAFETY_REPORT = 'SET_SAFETY_REPORT';

export const SET_SAFETY_CONFIGS = 'SET_SAFETY_CONFIGS';
export const CREATE_SAFETY_CONFIG = 'CREATE_SAFETY_CONFIG';
export const UPDATE_SAFETY_CONFIG = 'UPDATE_SAFETY_CONFIG';
export const DELETE_SAFETY_CONFIG = 'DELETE_SAFETY_CONFIG';
